import React, {useState} from 'react';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';

function RenderOptionTextComp({initialOptions = ['', ''], placeholderText, minLength, maxLength}) {
  const [options, setOptions] = useState(initialOptions)

  const handleOptionChange = (value, index) => {
    const optionsTemp = [...options]
    optionsTemp[index] = value
    setOptions(optionsTemp)
  }

  const handleAddOption = (isAdd, removeIndex) => {
    const optionsTemp = [...options]
    if (isAdd) {
      optionsTemp.push('')
    } else {
      optionsTemp.splice(removeIndex, 1)
    }
    setOptions(optionsTemp)
  }

  const renderOptionText = ({inputId, optionNumber, option, index}) => {
    return <FormControl sx={{m: 1}} variant="outlined">
      <InputLabel htmlFor={inputId}>{optionNumber}</InputLabel>
      <OutlinedInput
        id={inputId}
        type={'text'}
        value={option}
        label={optionNumber}
        onChange={({target}) => handleOptionChange(target.value, index)}
        endAdornment={
          <InputAdornment position="end">
            0/30
            {index >= minLength &&
              <IconButton
                aria-label="Remove option"
                onClick={() => handleAddOption(false, index)}
                edge="end"
              >
                <DeleteIcon/>
              </IconButton>
            }
          </InputAdornment>
        }
      />
    </FormControl>
  }

  return (
    <div>
      <FormControl sx={{m: 1}} variant="outlined">
        {options.map((option, index) => {
          const optionNumber = `${placeholderText} ${index + 1}`
          const inputId = `outlined-adornment-${index}`
          return <> {renderOptionText({inputId, optionNumber, option, index})}
          </>
        })}
      </FormControl>
      <div>
        <Button size="small" startIcon={<AddIcon/>} onClick={() => handleAddOption(true)}
                disabled={options.length >= maxLength}>
          Add more
        </Button>
      </div>
    </div>
  )
}

export default RenderOptionTextComp